import { render, staticRenderFns } from "./screenTransabilida.vue?vue&type=template&id=663558d6"
import script from "./screenTransabilida.vue?vue&type=script&lang=js"
export * from "./screenTransabilida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports